<div class="modol_comp">
    <div class="modal-header pb-0 pt-0 d-flex">
        <button class="button-close" mat-button [mat-dialog-close]="false">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                    d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
            </svg>
        </button>
    </div>
    <div class="modal-body pt-0">
        <h2> {{'Take Payment'}}</h2>

        <form class="" [formGroup]="creditCardForm" *ngIf="paymentOnline == 'credit'">
            <div class="row mt-0">

                <div class="col-md-12 form-group">
                    <label class="mt-0">Client Company name</label>
                    <input type="text" class="form-control mt-2" placeholder="Search" [ngClass]="{ 'is-invalid': submitted && f['clientName'].errors}"
                        [ngClass]="{'highlight-input': true}" formControlName="clientName" [matAutocomplete]="auto" />
                    <mat-autocomplete #auto="matAutocomplete">
                        <div *ngIf="totalClientCount > 0">
                            <mat-option *ngFor="let client of clientList " [value]="client?.name" [id]="client?._id"
                                (click)="selectedClient(client)">
                                {{client?.name}}
                            </mat-option>
                        </div>
                        <div *ngIf="totalClientCount === 0">
                            <mat-option [disabled]="true">{{'No Client Found'}}</mat-option>
                        </div>
                    </mat-autocomplete>
                    <div *ngIf="submitted && f['clientName'].errors" class="invalid-feedback" style="display: block;">
                        <ng-container *ngIf="f['clientName'].errors['required']">
                            {{'Client name is required.'}}
                        </ng-container>
                    </div>
                </div>

                <div class="form-group col-md-12">
                    <label class="">Email</label>
                    <input class="form-control mt-3" formControlName="email" type="text" placeholder="Enter Email"
                        [ngClass]="{ 'is-invalid': submitted && f['email'].errors}">
                    <div *ngIf="submitted && f['email'].errors" class="invalid-feedback" style="display: block;">
                        <ng-container *ngIf="f['email'].errors['required']">
                            {{'email is required.'}}
                        </ng-container>
                        <div *ngIf="submitted && (f['email'].errors['email'] || f['email'].errors['pattern'] )">
                            {{validationErrorMessage.validEmail}}</div>
                    </div>
                </div>

                <div class="form-group col-md-12 country-code">
                    <label class="">Phone Number</label>
                    <div class="country-code-input pe-1">
                        <div class="d-flex align-items-center">
                            <div>+1</div> &nbsp;
                            <div class="drop-down-icon"></div>
                        </div>
                    </div>
                    <input class="form-control mt-3" formControlName="phoneNumber" type="text"
                        placeholder="Enter Phone Number" maxlength="10"
                        [ngClass]="{ 'is-invalid': submitted && f['phoneNumber'].errors}">
                    <div *ngIf="submitted && f['phoneNumber'].errors" class="invalid-feedback" style="display: block;">
                        <ng-container *ngIf="f['phoneNumber'].errors['required']">
                            {{'Phone Number is required.'}}
                        </ng-container>
                    </div>
                </div>

                <div class="form-group col-md-12">
                    <div class="dollar">
                        <span class="">$</span>
                        <label class="">Amount</label>
                        <input class="form-control mt-3" formControlName="amount" type="text" placeholder="Enter Amount"
                            type="number" min="0" (keydown.space)="$event.preventDefault()"
                            (keypress)="validationService.numberWithDecimal($event)" (blur)="setTodecimal()"
                            [ngClass]="{ 'is-invalid': submitted && f['amount'].errors}">
                    </div>
                    <div *ngIf="submitted && f['amount'].errors" class="invalid-feedback" style="display: block;">
                        <ng-container *ngIf="f['amount'].errors['required']">
                            {{'Amount is required.'}}
                        </ng-container>
                    </div>
                </div>

                <div class="form-group col-md-12">
                    <label class="">Card Holder's name</label>
                    <input class="form-control mt-3" formControlName="holderName" type="text"
                        placeholder="Enter Card Holder's name"
                        [ngClass]="{ 'is-invalid': submitted && f['holderName'].errors}">
                    <div *ngIf="submitted && f['holderName'].errors" class="invalid-feedback" style="display: block;">
                        <ng-container *ngIf="f['holderName'].errors['required']">
                            {{'Holder\'s name is required.'}}
                        </ng-container>
                        <ng-container
                            *ngIf="f['holderName'].errors['fiveWords'] && !f['holderName'].errors['required']">
                            {{'The holder name must consist of exactly 5 words.'}}
                        </ng-container>
                    </div>
                </div>

                <div class="form-group col-md-12">
                    <label class="">Card Number</label>
                    <input id="cc-number" class="form-control mt-3" formControlName="cardNumber" type="tel"
                        placeholder="Enter Card Number" autocomplete="cc-number" ccNumber
                        [ngClass]="{ 'is-invalid': submitted && f['cardNumber'].errors}">
                    <div *ngIf="submitted && f['cardNumber'].errors" class="invalid-feedback" style="display: block;">
                        <ng-container *ngIf="f['cardNumber'].errors['required']; else elseTemplate">
                            {{'Card Number is required.'}}
                        </ng-container>
                        <ng-template #elseTemplate>
                            {{'Enter a valid card number.'}}
                        </ng-template>
                    </div>
                </div>
                <div class="form-group col-md-12">
                    <label class="">Expiry Date</label>
                    <input id="cc-exp-date" class="form-control mt-3" formControlName="expirationDate" type="tel"  maxlength="7"
                        placeholder="Enter Expiry date" autocomplete="cc-exp" ccExp
                        [ngClass]="{ 'is-invalid': submitted && f['expirationDate'].errors}">
                    <div *ngIf="submitted && f['expirationDate'].errors" class="invalid-feedback"
                        style="display: block;">
                        <ng-container *ngIf="f['expirationDate'].errors['required']; else elseTemplate">
                            {{'Expiry Date is required.'}}
                        </ng-container>
                        <ng-template #elseTemplate>
                            {{'Enter a valid expiry date'}}
                        </ng-template>
                    </div>
                </div>
                <div class="form-group col-md-12">
                    <label class="">CVC</label>
                    <input id="cc-number" class="form-control mt-3" formControlName="cardCode" type="tel"
                        type="password" maxlength="4" type="password" placeholder="Enter CVC" autocomplete="cc-number"
                        [ngClass]="{ 'is-invalid': submitted && f['cardCode'].errors}">
                    <div *ngIf="submitted && f['cardCode'].errors" class="invalid-feedback" style="display: block;">
                        <ng-container *ngIf="f['cardCode'].errors['required']">
                            CVC is required.
                        </ng-container>
                        <ng-container *ngIf="f['cardCode'].errors['invalidCVC']">
                            Invalid CVC. CVC must be 3-4 numeric digits.
                        </ng-container>
                    </div>
                </div>
                <div class="form-group col-md-12">
                    <label class="">Notes</label>
                    <textarea type="text" class="form-control mt-3" formControlName="notes"
                        [ngClass]="{ 'is-invalid': submitted && f['notes'].errors}" placeholder="Enter notes" ></textarea>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn cancel" [mat-dialog-close]="false">Cancel</button>
        <!-- <button type="submit" class="btn delete-btn" *ngIf="data.type==2">Delete</button> -->
        <button type="submit" class="btn delete" (click)="chargeSubmit()">{{'Pay'}}</button>
    </div>

</div>